<script setup lang="ts">

</script>

<template>
    <a class="flex items-center gap-x-2 text-lg text-white bg-green-700
              hover:bg-green-800 focus:ring-4
              focus:ring-green-300 font-medium rounded-lg px-5 py-2.5
              dark:bg-green-600 dark:hover:bg-green-700 focus:outline-none
              dark:focus:ring-green-800"
       :href="$route('qr-code-history.index')">

        <svg class="w-7 h-7 text-gray-800 dark:text-white"
             aria-hidden="true"
             xmlns="http://www.w3.org/2000/svg"
             width="24"
             height="24"
             fill="none"
             viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9 8h10M9 12h10M9 16h10M4.99 8H5m-.02 4h.01m0 4H5"/>
        </svg>

        {{ $page.props.text_history_list }}
    </a>
</template>

<style scoped>

</style>
